import React, { useState, useEffect } from 'react';
import s from "./DeviceInfo.module.css"
import { useUser } from '../../Context/UserContext';
import { sendQueueToDevice, sendQueueToDevice2 } from "../../Api/DevicesApi"
import { useNavigate } from 'react-router-dom';
import { EditIcon } from '../shared/Icon';
import { showAccessAlert } from "../Utils/Utils";
import { AlertBar } from '../shared/AlertBar';
import { ModalTemplate } from "../shared/ModalForms";
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { CustomBarChart } from './CustomBarChart';
import { ConsumptionTable } from './ConsumptionTable';
import { DeviceEditForm, DeviceAddrEditForm } from './DeviceEditForm';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import RSSIInfo from './RSSIInfo';



export default function DeviceInfo({ deviceId, onBackClick, handleInfoLogsClick }) {
    const [open, setOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ severity: 'info', message: '' });

    const deviceInfo = useDeviceInfo(deviceId, alertInfo);
    
    const { user } = useUser();
    const notAllowedGroups = ['USER'];
    const isNotAllowed = notAllowedGroups.includes(user.role);
    const [editingDevice, setEditingDevice] = useState(false);
    const [editingAddrDevice, setEditingAddrDevice] = useState(false);
    const [selectedOption, setSelectedOption] = useState(1);
    const [period, setPeriod] = useState('2M');
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        if (user && user.organization && user.organization.length > 0) {
            const organization = user.organization[0];
            if (organization.template) {
                const templateArray = Object.values(organization.template);
                setTemplates(templateArray);
            }
        }
    }, [user]);

    const org = user.organization && user.organization.length > 0 ? user.organization[0].id : null;

    const navigate = useNavigate();

    const handleBackClick = () => {
        onBackClick();
        navigate('/devices');
    };

    useEffect(() => { }, [deviceId, alertInfo]);

    const displayNames = {
        user: 'Пользователь',
        device: 'Устройство',
        deviceIoT: 'IoT Устройство',
        data: 'Данные',
        paidInfo: 'Платежная Информация'
    };

    const handleEditClick = () => {
        setEditingDevice(true);
    };

    const handleEditAddrClick = () => {
        setEditingAddrDevice(true);
    };

    const closeModal = () => {
        setEditingDevice(false);
        setEditingAddrDevice(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendQuene = async () => {

        const deveui = deviceInfo.deviceIoT["Серийный номер"]
        try {
            await sendQueueToDevice(deveui);
        } catch (error) {
            console.error('Failed to send queue:', error);
        }
    }

    const handleSendQuene2 = async () => {

        const deveui = deviceInfo.deviceIoT["Серийный номер"]
        try {
            await sendQueueToDevice2(deveui);
        } catch (error) {
            console.error('Failed to send queue:', error);
        }
    }


    if (!deviceInfo) {
        return null;
    }

    const dev_type = deviceInfo.deviceIoT['Тип устройства']

    const getClassForStatus = (status) => {
        const normalized = (status || '').toLowerCase();
        switch (normalized) {
            case 'problem':
                return s.ownerLogoproblem;
            case 'online':
                return s.ownerLogoonline;
            case 'warn':
                return s.ownerLogowarn;
            default:
                return '';
        }
    };

    const statusClass = getClassForStatus(deviceInfo.status);

    return (
        <>
            <AlertBar open={open} handleClose={handleClose} message={alertInfo.message} severity={alertInfo.severity} />
            <div className={s.infoGrid}>
                <div className={s.forwardback} onClick={handleBackClick}>
                    <div className={s.backIcon}>
                        <img src={'/forwardback.svg'}></img>
                    </div>
                    <div className={s.forwardbackText}>Назад</div>
                </div>

                <div className={s.buttonsGroup}>
                    {dev_type === 'CC101' && (
                        <div className={s.quene} onClick={handleSendQuene}>
                            <div className={s.copyCardText}>Запросить данные с устройства</div>
                        </div>
                    )}
                    {dev_type === 'SML-N2' && (
                        <>
                            <RSSIInfo serialnumber={deviceInfo.deviceIoT["Серийный номер"]} />
                            <div className={s.quene} onClick={handleSendQuene2}>
                                <div className={s.copyCardText}>Запросить данные сигнала</div>
                            </div>

                        </>
                    )}

                    <div className={s.logs} onClick={handleInfoLogsClick}>
                        <div className={s.logsIcon}>
                            <img src={'/log.svg'}></img>
                        </div>
                        <div className={s.logsText}>Лог</div>
                    </div>
                    {/* <div className={s.copyCard}>
                        <div className={s.copyCardText}>Дублировать карточку устройства</div>
                    </div> */}
                </div>

                <div className={s.title}>
                    <div className={s.owner}>
                        <div className={s.ownerText}>{deviceInfo.user.ownership}</div>
                        <div className={statusClass}>
                            <div className={s.ownerLogoWarp}>
                                <img src={`/${(deviceInfo.status || '').toLowerCase()}.svg`} alt="status" />
                                <img src={'/lock.svg'} alt="lock" />
                            </div>
                        </div>
                    </div>
                    <div className={s.addrGroup}>
                        <div className={s.address}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 0C5.24267 0 3 2.24267 3 5C3 8.5 8 14 8 14C8 14 13 8.5 13 5C13 2.24267 10.7573 0 8 0ZM8 6.5C7.17157 6.5 6.5 5.82843 6.5 5C6.5 4.17157 7.17157 3.5 8 3.5C8.82843 3.5 9.5 4.17157 9.5 5C9.5 5.82843 8.82843 6.5 8 6.5Z" fill="#466AE9" />
                            </svg>
                            {deviceInfo.user.address}
                        </div>
                        <div className={s.address}
                            onClick={() => {
                            if (isNotAllowed) {
                                showAccessAlert();
                            } else {
                                handleEditAddrClick();
                            }
                        }}>
                            <EditIcon fill={"#466AE9"} />
                        </div>
                    </div>
                </div>
                <div className={s.infoWarp}>
                    <div className={s.device}>
                        <div className={s.deviceTitle}>
                            {displayNames.device}
                        </div>
                        {Object.entries(deviceInfo.device).map(([key, value]) => (
                            <div className={s.listItem} key={key}>
                                <div className={s.listItemKey}>{key}</div>
                                <div className={s.listItemValue}>{value}</div>
                            </div>
                        ))}
                    </div>

                    <div className={s.deviceIot}>
                        <div className={s.deviceTitle}>
                            {displayNames.deviceIoT}
                        </div>
                        {Object.entries(deviceInfo.deviceIoT).map(([key, value]) => (
                            <div className={s.listItem} key={key}>
                                <div className={s.listItemKey}>{key}</div>
                                <div className={s.listItemValue}>{value}</div>
                            </div>
                        ))}
                    </div>

                    <div className={s.paidInfo}>
                        <div className={s.deviceTitle}>
                            {displayNames.paidInfo}
                        </div>
                        {Object.entries(deviceInfo.paidInfo).map(([key, value]) => (
                            <div className={s.listItem} key={key}>
                                <div className={s.listItemKey}>{key}</div>
                                <div className={s.listItemValue}>{value}</div>
                            </div>
                        ))}
                    </div>

                    <div className={s.editButton}
                        onClick={() => {
                            if (isNotAllowed) {
                                showAccessAlert();
                            } else {
                                handleEditClick();
                            }
                        }}>
                        <EditIcon fill={"white"} opacity={"0.7"} />
                        <div className={s.editText}>Редактировать</div>
                    </div>

                </div>

                <ConsumptionTable deviceId={deviceId} templates={templates} org={org} devType={dev_type} />

                <div className={s.graphContainer}>
                    <div className={s.graphActions}>
                        <div className={s.graphTitle}>График общего потребления</div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <select className={s.graphSelect} onChange={(e) => setSelectedOption(Number(e.target.value))}>
                                <option value="1">По месяцам</option>
                                <option value="0">По дням</option>
                            </select>
                            {selectedOption === 1 && (
                                <ToggleButtonGroup
                                    value={period}
                                    exclusive
                                    onChange={(event, newPeriod) => {
                                        if (newPeriod !== null) {
                                            setPeriod(newPeriod);
                                        }
                                    }}
                                    aria-label="period selection"
                                    size="small"
                                >
                                    <Tooltip title="Последние 2 месяца" arrow>
                                        <ToggleButton value="2M" aria-label="2 months">
                                            2М
                                        </ToggleButton>
                                    </Tooltip>
                                    <Tooltip title="Последние 3 месяца" arrow>
                                        <ToggleButton value="3M" aria-label="3 months">
                                            3М
                                        </ToggleButton>
                                    </Tooltip>
                                    <Tooltip title="Последние 6 месяцев" arrow>
                                        <ToggleButton value="6M" aria-label="6 months">
                                            6М
                                        </ToggleButton>
                                    </Tooltip>
                                    <Tooltip title="Последний год" arrow>
                                        <ToggleButton value="1Y" aria-label="1 year">
                                            1Г
                                        </ToggleButton>
                                    </Tooltip>
                                </ToggleButtonGroup>
                            )}

                        </div>
                    </div>
                    <CustomBarChart id={deviceId} aggrType={selectedOption} deviceType={deviceInfo} period={period} />
                </div>
                {editingDevice && (
                    <DeviceEdit deviceId={deviceId} isOpen={!!editingDevice} closeModal={closeModal} setAlertInfo={setAlertInfo} setOpen={setOpen} />
                )}

                {editingAddrDevice && (
                    <DeviceAddrEdit deviceInfo={deviceInfo} deviceId={deviceId} isOpen={!!editingAddrDevice} closeModal={closeModal} setAlertInfo={setAlertInfo} setOpen={setOpen} />
                )}
                <div className={s.empty}></div>
            </div>
        </>
    )
}

function DeviceEdit({ closeModal, isOpen, deviceId, setAlertInfo, setOpen }) {
    return (
        <>
            <ModalTemplate open={isOpen} onClose={closeModal} maxWidth='lg' title={"Редактирование устройства"}>
                <DeviceEditForm deviceId={deviceId} closeModal={closeModal} setAlertInfo={setAlertInfo} setOpen={setOpen} />
            </ModalTemplate>
        </>
    );
}


function DeviceAddrEdit({ deviceInfo, closeModal, isOpen, deviceId, setAlertInfo, setOpen }) {
    return (
        <>
            <ModalTemplate open={isOpen} onClose={closeModal} title={"Редактирование адреса"}>
                <DeviceAddrEditForm deviceInfo={deviceInfo} deviceId={deviceId} closeModal={closeModal} setAlertInfo={setAlertInfo} setOpen={setOpen} />
            </ModalTemplate>
        </>
    );
}
